import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { Navigation } from '@ucheba/ui/components/Navigation/desktop'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { ISpecialitiesByProfProps } from '../types'
import { SpecialitiesList } from '../../../../../../components/SpecialitiesList/desktop'
import { useSpecialitiesByProf } from '../bll'

const Block = styled.div``

/** Подходящие специальности */
const SpecialitiesByProf: FC<ISpecialitiesByProfProps> = (props) => {
  const { items, title } = props
  const isAuth = useSelector(authSelectors.isAuth)
  const { navItems, activeIndex, handleClick, total, onClickGetMoreSpecialities } =
    useSpecialitiesByProf(props)

  return (
    <Block id='specialities'>
      <Heading h2={title || 'Подходящие специальности'} spacing='small' />

      {navItems && navItems.length > 0 && (
        <>
          <Navigation items={navItems} activeIndex={activeIndex} onClick={handleClick} />

          <Spacing spacing='xlarge' />
        </>
      )}

      {items.length > 0 && (
        <LimitedList
          items={items}
          limit={5}
          onShowAll={onClickGetMoreSpecialities}
          buttonText='Все подходящие специальности'
          id='specialities-all'
          isAuth={isAuth}
          total={total}
          showAllButtonLinkIsLink={false}
        >
          {({ limitedItems }) => <SpecialitiesList items={limitedItems} />}
        </LimitedList>
      )}
    </Block>
  )
}

export default memo(SpecialitiesByProf)
